"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var React = __importStar(require("react"));
var SvgGmail = function (props) { return ((0, jsx_runtime_1.jsxs)("svg", __assign({ width: 17, height: 13, fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: [(0, jsx_runtime_1.jsx)("path", { d: "M12.9 1.108 8.548 4.506 4.093 1.108l.005.005v4.758l4.398 3.472 4.405-3.338V1.108Z", fill: "#EA4335" }), (0, jsx_runtime_1.jsx)("path", { d: "m14.044.281-1.143.827v4.897l3.598-2.762V1.579S16.062-.798 14.044.28Z", fill: "#FBBC05" }), (0, jsx_runtime_1.jsx)("path", { d: "M12.9 6.006v6.352h2.759s.784-.08.841-.975v-8.14l-3.6 2.763Z", fill: "#34A853" }), (0, jsx_runtime_1.jsx)("path", { d: "M4.098 12.364V5.87l-.005-.004.005 6.497ZM4.093 1.109 2.956.287C.938-.793.5 1.583.5 1.583v1.665l3.593 2.619V1.109Z", fill: "#C5221F" }), (0, jsx_runtime_1.jsx)("path", { d: "M4.093 1.109v4.758l.005.004V1.113l-.005-.004Z", fill: "#C5221F" }), (0, jsx_runtime_1.jsx)("path", { d: "M.5 3.248v8.14a.982.982 0 0 0 .841.976H4.1l-.006-6.497L.5 3.248Z", fill: "#4285F4" })] }))); };
exports.default = SvgGmail;
